var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[_c('GHeader',{staticClass:"block z-100",class:{
      sticky: _vm.isStickyHeader || _vm.$breakpoints.lg,
      'top-0': _vm.isStickyHeader || _vm.$breakpoints.lg,
    },attrs:{"title":_vm.title,"hide-sp-title":_vm.hideSpTitle,"hide-sp-search":_vm.hideSpSearch,"hide-back-button":_vm.hideBackButton},on:{"onShowSidebar":_vm.onShowSidebar},scopedSlots:_vm._u([(_vm.hasRightButton)?{key:"rightButton",fn:function(){return [_vm._t("rightButton")]},proxy:true}:null],null,true)}),_c('Sidebar',{staticClass:"z-110",attrs:{"is-open":_vm.showSidebar},on:{"onClose":_vm.onCloseSidebar}}),_vm._t("pageHeader"),_c('div',{staticClass:"\n      block\n      mx-0\n      lg:min-w-screen-lg lg:max-w-screen-lg lg:mx-auto lg:flex\n      flex-grow\n    "},[(_vm.$breakpoints.lg && !_vm.hidePcSidebar)?_c('div',{staticClass:"left"},[_vm._t("pcSidebar")],2):_vm._e(),_c('div',{class:[
        'w-full',
        'right',
        {
          padded: _vm.padded,
          'mx-auto': _vm.hidePcSidebar,
          'md:bg-gray-50': !_vm.hidePcSidebar || _vm.pcGrayBackground,
        } ]},[(!_vm.hideBreadcrumbs)?_c('Breadcrumbs',{staticClass:"pt-4 px-2 lg:pt-0 lg:px-0"}):_vm._e(),(!_vm.hidePcTitle && (_vm.showSpTitle || _vm.$breakpoints.lg))?_c('div',{class:[
          {
            hidden: !_vm.showSpTitle,
            flex: _vm.showSpTitle,
            'px-3': _vm.showSpTitle,
          },
          'mt-3',
          'mb-6',
          'lg:flex',
          'items-center',
          {
            'justify-between': !_vm.isTitleCentered,
            'justify-center': _vm.isTitleCentered,
          } ]},[_c('h1',{staticClass:"text-md"},[_vm._v(_vm._s(_vm.title))]),_vm._t("rightButton")],2):_vm._e(),_vm._t("default")],2)]),(_vm.showFooter)?_c('GFooter'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }